/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DndModule } from 'ng2-dnd';
import { FaqComponent } from './faq.page';
export const routes: Routes = [
    { path: 'faq', component: FaqComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DndModule.forRoot(),
        RouterModule.forChild(routes)
    ],
    declarations: [
        FaqComponent
    ]
})
export class FaqModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/faq/faq.module.ts